import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtroClientesCerrados'
})
export class FiltroClientesCerradosPipe implements PipeTransform {

  transform(arreglo: any[], texto: string): any[] {
   
    //console.log(arreglo)

    if(texto ===''){
      return arreglo
    }
    if( arreglo.length === 0 ) {
      return arreglo;
    }

    texto = texto.toLocaleLowerCase()

    return arreglo.filter (item=>{
        //console.log(item.numero, 'desde pipe');
        var numeroActual
        var id
        if(item.numero==null){
           
            numeroActual =''
            id = ''

        }else 
        {
          numeroActual =item.numero.numeroCliente
          id = item.numero.id
          console.log(id);
        }


            if(item.numero!=null &&item.numero.registrosCliente!=null && item.numero.registrosCliente.nombre){

return item.numero.numeroCliente.toLocaleLowerCase().includes(texto) || item.numero.registrosCliente.nombre.toLocaleLowerCase().includes(texto) || item.numero.id.toString().includes(texto)
            }         

    //   if(item.numero.registrosCliente.nombre){
    //     return item.numero.numeroCliente.toLocaleLowerCase().includes(texto) || item.numero.registrosCliente.nombre.toLocaleLowerCase().includes(texto)

    //   }
     // return item.numero.numeroCliente.toLocaleLowerCase().includes(texto)
     return numeroActual.toLocaleLowerCase().includes(texto) || id.toString().includes(texto)
     
     
    })
   
    return arreglo;
  }

}
